// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionTokenWithPromise } from "../config/userPool";

const { ANNOTATION_ENDPOINT } = config.api_endpoint;
const initialState = {
  loading: true,
  annotation: [],
  marker: [],
  error: null,
};

const combineAndSortAnnotations = (polygonData, markerData) => {
  const polygonFeatures = (polygonData?.features || []).map((feature) => ({
    ...feature,
    properties: {
      ...feature.properties,
      date: new Date(feature.properties.date).toISOString(),
    },
  }));

  const markerFeatures = (markerData || []).map((marker) => ({
    id: marker.id.toString(),
    type: "Feature",
    properties: {
      name: marker.name,
      distance: null,
      date: new Date(marker.date).toISOString(),
    },
    geometry: {
      type: "Point",
      coordinates: [[marker.Lng, marker.Lat]],
    },
  }));

  const combined = [...polygonFeatures, ...markerFeatures];

  const sortedFeatures = combined.sort(
    (a, b) => new Date(a.properties.date) - new Date(b.properties.date) // Oldest first
  );

  return {
    type: "FeatureCollection",
    features: sortedFeatures,
  };
};


export const fetchAllANNOTATIONS = createAsyncThunk(
  "annotation/fetchAllANNOTATIONS",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getCurrentLoggedInSessionTokenWithPromise();
      const results = await api.get(ANNOTATION_ENDPOINT, {}, token);
      console.log(results);
      const polygonData = results.markup[0].PolygonData;
      const markerData = results.markup[0].Marker;

      const combinedSortedGeoJSON = combineAndSortAnnotations(polygonData, markerData);

      return {
        annotation: combinedSortedGeoJSON,  // ✅ sorted & merged
        polygon: polygonData,
        marker: markerData,
      };
    } catch (error) {
      console.log("error: ", error);
      return rejectWithValue(error.details);
    }
  }
);

const annotationSlice = createSlice({
  name: "annotation",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllANNOTATIONS.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllANNOTATIONS.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.annotation = action.payload.annotation;
        state.marker = action.payload.marker;
      })
      .addCase(fetchAllANNOTATIONS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

const annotationReducer = annotationSlice.reducer;
export default annotationReducer;
